namespace GeniuzPOS.QRreport {
    export enum GroupType {
        GroupType1 = 1,
        GroupType2 = 2,
        GroupType3 = 3,
        GroupType4 = 4
    }
    Serenity.Decorators.registerEnumType(GroupType, 'GeniuzPOS.QRreport.GroupType');
}
